import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import { Primary } from "./";
import config from "@lib/config";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const drawerWidth = config.drawerWidth;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    paddingTop: "70px",
    height: "calc(100vh-70px)",
    position: "fixed",
    zIndex: theme.zIndex.drawer,
    "& .MuiDrawer-paper": {
      overflow: "visible",
      borderRight: "none",
      position: "relative",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: "border-box",
      ...(!open && {
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: "77px",
      }),
    },
    "--nav-icon-size": open ? "var(--icon-size-sm)" : "var(--icon-size-md)",
    "--nav-item-padding-y": open ? "var(--space-2)" : "var(--space-3)",
    ".MuiListItemIcon-root": {
      minWidth: "auto",
      marginRight: "var(--space-2)",
    },
    ".MuiListItemText-root": {
      display: open ? "block" : "none",
    },
    ".MuiListSubheader-root": {
      display: open ? "block" : "none",
    },
    ".MuiTypography-root": {
      display: open ? "block" : "none",
    },
  })
);

const ToggleButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: "calc(50% - 34px)",
  right: "-10px",
  width: "20px",
  height: "34px",
  boxShadow: theme.shadows[1],
  zIndex: "1300",
  borderRadius: "3px",
  backgroundColor: "white",

  "&:hover": {
    backgroundColor: theme.palette.grey[200],
  },
}));

const NavList = styled(List)(({ theme }) => ({
  borderRight: "1px solid",
  borderColor: theme.palette.grey[300],
  height: "calc(100vh - 70px)",
  paddingTop: 0,
}));

export default function Main({ open, toggleDrawer }) {
  return (
    <Drawer variant="permanent" open={open}>
      <ToggleButton onClick={toggleDrawer}>
        {open && <ChevronLeftIcon sx={{ color: (theme) => theme.palette.grey[700] }} />}
        {!open && <ChevronRightIcon sx={{ color: (theme) => theme.palette.grey[700] }} />}
      </ToggleButton>
      <NavList component="nav">
        <Primary open={open} />
      </NavList>
    </Drawer>
  );
}
